const DEV_MODE = false

export const API_BASE           = DEV_MODE?'http://localhost:6587/':'https://files-set.faculdadereboucas.com.br/'
export const UPLOAD_BASE        = DEV_MODE?'http://localhost:6587/uploads/':'https://files.faculdadereboucas.com.br/'

